import { Link } from "react-router-dom";
import Logo, { NomMark } from "@/components/Logo";
import { COMPANY, scrollToId } from "@/lib/site";
import { useLocation } from "react-router-dom";

export default function Footer() {
  const { pathname } = useLocation();
  const onHome = pathname === "/";
  const go = (id) => (e) => {
    e.preventDefault();
    if (onHome) scrollToId(id);
    else window.location.href = `/#${id}`;
  };

  return (
    <footer className="bg-nom-ink text-white" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-6 py-14 sm:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2.5">
              <NomMark className="h-9 w-9" />
              <span className="font-display text-2xl font-semibold">Nom Apps LLC</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/70">
              A Wisconsin software company building consumer mobile applications. Our first app, NomNom: AI Calorie
              Tracker, is a friendly nutrition and wellness companion — available now on the App Store and Google Play.
            </p>
            <a
              href={`mailto:${COMPANY.email}`}
              data-testid="footer-email-link"
              className="mt-5 inline-block rounded-full border border-white/20 px-5 py-2.5 text-sm font-bold text-white transition-colors duration-200 hover:border-nom-coral hover:text-nom-coral"
            >
              {COMPANY.email}
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="font-display text-sm font-semibold uppercase tracking-widest text-white/50">Explore</p>
            <ul className="mt-4 space-y-3 text-sm font-bold">
              {[
                { id: "about", label: "About" },
                { id: "nomnom", label: "NomNom" },
                { id: "contact", label: "Contact" },
              ].map((l) => (
                <li key={l.id}>
                  <a href={`/#${l.id}`} onClick={go(l.id)} data-testid={`footer-${l.id}-link`} className="text-white/80 transition-colors hover:text-nom-coral">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-display text-sm font-semibold uppercase tracking-widest text-white/50">Legal</p>
            <ul className="mt-4 space-y-3 text-sm font-bold">
              <li>
                <Link to="/privacy" data-testid="footer-privacy-link" className="text-white/80 transition-colors hover:text-nom-coral">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-terms-link" className="text-white/80 transition-colors hover:text-nom-coral">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/delete-account" data-testid="footer-delete-account-link" className="text-white/80 transition-colors hover:text-nom-coral">
                  Delete Your Account
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Nom Apps LLC · {COMPANY.location}</p>
          <p>NomNom: AI Calorie Tracker is available on the App Store and Google Play.</p>
        </div>
      </div>
    </footer>
  );
}
